import { registerProduct } from "../../registry/product-registry";
import { shopperAgentProductConfig } from "./tasks";

let registered = false;

export function registerShopperAgentProduct(): void {
  if (registered) return;
  registerProduct(shopperAgentProductConfig);
  registered = true;
}
